import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module basic-styles/code/codeediting
 */
import { Plugin } from 'ckeditor5/src/core.js';
import { TwoStepCaretMovement, inlineHighlight } from 'ckeditor5/src/typing.js';
import AttributeCommand from '../attributecommand.js';
var CODE = 'code';
var HIGHLIGHT_CLASS = 'ck-code_selected';
/**
 * The code editing feature.
 *
 * It registers the `'code'` command and introduces the `code` attribute in the model which renders to the view
 * as a `<code>` element.
 */
var CodeEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(CodeEditing, _Plugin);
  var _super = _createSuper(CodeEditing);
  function CodeEditing() {
    _classCallCheck(this, CodeEditing);
    return _super.apply(this, arguments);
  }
  _createClass(CodeEditing, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var editor = this.editor;
      // Allow code attribute on text nodes.
      editor.model.schema.extend('$text', {
        allowAttributes: CODE
      });
      editor.model.schema.setAttributeProperties(CODE, {
        isFormatting: true,
        copyOnEnter: false
      });
      editor.conversion.attributeToElement({
        model: CODE,
        view: 'code',
        upcastAlso: {
          styles: {
            'word-wrap': 'break-word'
          }
        }
      });
      // Create code command.
      editor.commands.add(CODE, new AttributeCommand(editor, CODE));
      // Enable two-step caret movement for `code` attribute.
      editor.plugins.get(TwoStepCaretMovement).registerAttribute(CODE);
      // Setup highlight over selected element.
      inlineHighlight(editor, CODE, 'code', HIGHLIGHT_CLASS);
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'CodeEditing';
    }
    /**
     * @inheritDoc
     */
  }, {
    key: "requires",
    get: function get() {
      return [TwoStepCaretMovement];
    }
  }]);
  return CodeEditing;
}(Plugin);
export { CodeEditing as default };